"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const chat_service_g_1 = require("./chat-service.g");
class ChatService extends chat_service_g_1.ChatService {
    /**
    * Gets the attachment for the provided ID. This route may not be used in conversations with SMS participants.
    * @summary Get an attachment
    * @param {string} conversationId ConversationId
    * @param {string} attachmentId AttachmentId
    * @throws {RequiredError}
    */
    getAttachmentBinary(params) {
        // verify required parameter 'conversationId' is not null or undefined
        if (params.conversationId === null || params.conversationId === undefined) {
            throw new utils_1.RequiredError('conversationId', 'Required parameter conversationId was null or undefined when calling getAttachment.');
        }
        // verify required parameter 'attachmentId' is not null or undefined
        if (params.attachmentId === null || params.attachmentId === undefined) {
            throw new utils_1.RequiredError('attachmentId', 'Required parameter attachmentId was null or undefined when calling getAttachment.');
        }
        const path = `/conversations/{conversationId}/attachments/{attachmentId}`
            .replace(`{${'conversationId'}}`, String(params.conversationId))
            .replace(`{${'attachmentId'}}`, String(params.attachmentId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => {
            return {
                type: response.headers['content-type'],
                stream: response.body,
            };
        });
    }
    updateAttachmentBinary(params) {
        return this.updateAttachment(params);
    }
}
exports.ChatService = ChatService;
